module.exports = __webpack_public_path__ + "static/media/1.81a04f13.jpg";